.drawer {
  background-color: var(--color-uva-white);
  bottom: 0;
  box-shadow: 0 0 0.75rem 0.25rem rgb(0 0 0 / 10%);
  display: flex;
  flex-direction: column;
  left: 10vw;
  max-width: 90vw;
  min-width: 25rem;
  padding: 2.5rem 2rem;
  position: fixed;
  right: 0;
  top: 0;
  transform: translateX(100%);
  transform-origin: right;
  transition-duration: 200ms;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
}

.drawer__content {
  /**
     * Drawer content height cannot exceed the available height, dictated by its parent.
     * Subtracting top and bottom padding from .drawer as well as the height and bottom margin of
     * .drawer__heading from the parent's height gives us the maximum height the content should be.
     */
  max-height: calc(100vh - 7rem);
  overflow-y: auto;
}

.drawer__header {
  display: flex;
  gap: 2rem;
  justify-content: space-between;
  position: relative;
}

.drawer__footer {
  gap: 2rem;
  justify-content: flex-end;
  margin-top: auto;
}

.drawer__heading {
  font-size: var(--font-size-s);
  line-height: var(--line-height-s);
  margin: 0.25rem 0 0.5rem;
  padding-right: 2rem;
}

@media only screen and (min-width: 40rem) {
  .drawer {
    left: auto;
    max-width: 37.5rem;
  }
}

.drawer--open {
  transform: translateX(0);
  transition-duration: 250ms;
}

.drawer__buttons {
  display: flex;
  flex-flow: row wrap;
  gap: 0.75rem;
  justify-content: flex-end;
  margin: 2.5rem 0 0;
}
